// import path from 'path';

export const NACH_ROUTE = {
  index: {
    path: 'nach/*',
    to: '/nach',
  },
  dashboard: {
    path: 'dashboard',
    to: '/nach/dashboard',
  },
  mandate_link_dashboard: {
    path: 'mandate_link/dashboard',
    to: '/nach/mandate_link/dashboard',
  },
  create_mandate_link: {
    path: 'create_mandate_link',
    to: '/nach/create_mandate_link',
  },
  bank_master: {
    path: 'bank_master',
    to: '/nach/bank_master',
  },
  bank_master_update: {
    path: 'bank_master/update',
    to: '/nach/bank_master/update',
  },
  presentment: {
    path: 'presentment',
    to: '/nach/presentment',
  },
  mandate_approve: {
    path: 'mandate_approve',
    to: '/nach/mandate_approve',
  },
  bulk_upload: {
    path: 'bulk_upload',
    to: '/nach/bulk_upload',
  },
  webhook_nach_master: {
    path: 'webhook_nach_master',
    to: '/nach/webhook_nach_master',
  },
  updatewebhookurl: {
    path: 'webhook_nach_master/updateWebhookUrl',
    to: '/nach/webhook_nach_master/updateWebhookUrl',
  },
};
